import { router, useLocalSearchParams } from "expo-router";
import { ScrollView } from "react-native";
import { CounterForm } from "~/features/counters/CounterForm";
import { ModalHeader } from "~/components/ui/ModalHeader";
import { Screen } from "~/components/ui/Screen";
import { BodyText } from "~/components/ui/Text";
import { useCounters } from "~/state/counters";

export default function EditCounterScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const { counters, updateCounter, removeCounter } = useCounters();
  const counter = counters.find((item) => item.id === id);

  if (!counter) {
    return (
      <Screen>
        <ModalHeader title="Counter" onClose={() => router.back()} />
        <BodyText style={{ padding: 24 }}>This counter was removed.</BodyText>
      </Screen>
    );
  }

  return (
    <Screen>
      <ModalHeader title="Edit counter" onClose={() => router.back()} />
      <ScrollView keyboardShouldPersistTaps="handled">
        <CounterForm
          initial={counter}
          submitLabel="Save"
          onSubmit={async (value) => {
            await updateCounter(counter.id, value);
            router.back();
          }}
          onDelete={async () => {
            await removeCounter(counter.id);
            router.back();
          }}
        />
      </ScrollView>
    </Screen>
  );
}
